// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1m22I","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__b5Tth"};